import styled from "@emotion/styled";
import { Box } from "@mui/system";

export const NavStyle = styled(Box)`
  flex-shrink: 0;
`;

export const Content = styled(Box)`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;
